export default __webpack_public_path__ + "static/media/Level31.ac2a5f9f.svg";